import styled from "styled-components";

// export const Color = {
//     Header_Black: '#101010',
// };

export const Custom = {
  Margin_1: styled.span`
    margin-right: 1px;
  `,
  Margin_5: styled.span`
    margin-right: 5px;
  `,
  Margin_8: styled.span`
    margin: 0 4px;
    font-weight: 900;
  `,
  Margin_10: styled.span`
    margin: 0 5px;
  `,
  Margin_20: styled.span`
    margin: 0 10px;
  `,
  Margin1: styled.div`
    height: 1px;
  `,
  Margin5: styled.div`
    height: 5px;
  `,
  Margin8: styled.div`
    height: 8px;
  `,
  Margin10: styled.div`
    height: 10px;
  `,
  Margin20: styled.div`
    height: 20px;
  `,
  Bold_10: styled.span`
    font-size: 10px;
    font-weight: 700;
  `,
  Bold_12: styled.span`
    font-size: 12px;
    font-weight: 700;
  `,
  Bold_14: styled.span`
    font-size: 14px;
    font-weight: 700;
  `,
  Bold_16: styled.span`
    font-size: 16px;
    font-weight: 700;
  `,
  Bold_18: styled.span`
    font-size: 18px;
    font-weight: 700;
  `,
  Bold_20: styled.span`
    font-size: 20px;
    font-weight: 700;
  `,
  Medium_10: styled.span`
    font-size: 10px;
    font-weight: 400;
  `,
  Medium_12: styled.span`
    font-size: 12px;
    font-weight: 400;
  `,
  Medium_14: styled.span`
    font-size: 14px;
    font-weight: 400;
  `,
  Medium_16: styled.span`
    font-size: 16px;
    font-weight: 400;
  `,
  Medium_18: styled.span`
    font-size: 18px;
    font-weight: 400;
  `,
  Medium_20: styled.span`
    font-size: 20px;
    font-weight: 400;
  `,
  Extra_Bold_16: styled.span`
    font-size: 16px;
    font-weight: 900;
  `,
  Extra_Bold_20: styled.span`
    font-size: 20px;
    font-weight: 900;
  `,
  Extra_Bold_24: styled.span`
    font-size: 24px;
    font-weight: 900;
  `,
  Vertical_Line: styled.p`
    font-size: 40px;
    font-weight: 100;
    margin: 0;
  `,
};

export const Font = {};
